/* eslint-disable indent */
import DateRangePicker from '@src/main/shared/ui/components/calendar/DateRangePicker';
import { format } from 'date-fns';

export const makeDateBodyTemplate =
  <T extends object>(field: keyof T) =>
  (rowData: T) => {
    const dateValue = rowData[field] as unknown as Date | string | undefined;
    const date = dateValue ? new Date(dateValue) : null;
    return !date || Number.isNaN(date.getTime()) ? undefined : format(date, 'dd/MM/yyyy HH:mm');
  };

export const makeKeyAttachmentTemplate =
  <T extends { keyAttachment?: string; attachment?: string }>(
    t: (key: string) => string,
    download: (message: T) => void,
  ) =>
  ({ keyAttachment, attachment, ...rest }: T) =>
    keyAttachment ? (
      <button
        type="button"
        onClick={() => download({ keyAttachment, attachment, ...rest } as T)}
        style={{
          cursor: 'pointer',
          color: 'blue',
          textDecoration: 'underline',
          background: 'none',
          border: 'none',
          padding: 0,
        }}
        title={attachment || t('common.download')}
      >
        {t('common.download')}
      </button>
    ) : null;

export const makeAttachmentTemplate =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  <T extends { [key: string]: any }>(
      t: (key: string) => string,
      download: (item: T) => void,
      idField: keyof T = 'id',
      titleField: keyof T = 'formTitle',
    ) =>
    (rowData: T) => {
      const { [idField]: id, [titleField]: titleRaw } = rowData;
      const title = (titleRaw as string) || t('common.download');

      if (!id) return null;

      return (
        <button
          type="button"
          onClick={() => download(rowData)}
          style={{
            cursor: 'pointer',
            color: 'blue',
            textDecoration: 'underline',
            background: 'none',
            border: 'none',
            padding: 0,
          }}
          title={title}
        >
          {t('common.download')}
        </button>
      );
    };
export const DateRangeFilter = ({
  value,
  onChange,
  t,
}: {
  value: (Date | null)[] | null;
  onChange: (val: (Date | null)[] | null) => void;
  t: (key: string) => string;
}) => {
  const label = `${t('common.date.between')}:`;

  return (
    <>
      <div style={{ marginBottom: '12px' }}>{label}</div>
      <DateRangePicker value={value} onChange={onChange} />
    </>
  );
};
